"use strict";

initHome();
require("bootstrap");

var moment = require("moment");
var moreToBeSearched = true;
var executingSearch = false;
var apiVersion = 0;
var spaceKeyCode = 32;
var enterKeyCode = 13;

var localization = window.Localization;

(function () {

    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

function initHome() {

    $(function () {
        initApiVersion();
        initUdvalg();
        initSoeg();
        initDropdownHide();
        initFieldReset();
    });
}

function initApiVersion() {
    const ApiVersionUrl = "/api/agenda/apiVersion";
    $.ajax({
        url: ApiVersionUrl,
        type: "GET",
        async: true,
        success: function (apiVersionReturned) {
            apiVersion = apiVersionReturned;
        }
    });
}

function initUdvalg() {

    getUdvalgListeFromAction(true);

    $("#udvalg").on("change", function () {
        var udvalgId = $(this).val();
        if (udvalgId) {
            if (udvalgId === "-1") {
                getUdvalgListeFromAction(false);
            } else {
                getUdvalg(udvalgId);
            }
        }
    });
}

function getUdvalgListeFromAction(initial) {
    var urlGetUdvalg = "/api/agenda/udvalgsliste";
    $("#soeg .spinner").show();
    $.ajax({
        url: urlGetUdvalg,
        type: "GET",
        async: true,
        success: function (dataReturn) {
            if (initial) {

                var html = createDropdownHtml(dataReturn.Udvalg);
                $("#multidropdown").html(html).promise().done(function () {
                    window.resetDropdownOnKeyPress = resetDropdownOnKeyPress
                    window.resetDropdown = resetDropdown
                    initMultiDropdowns("[data-udvalgnavigation]");
                });

                var yearHtml = createYearDropdownHtml(dataReturn.Udvalg);
                $("#yearDropdown").html(yearHtml).promise().done(function () {
                    initMultiDropdowns("[data-yearnavigation]");
                });

                setLatestMeetingView(dataReturn.Udvalg);
            }

            setUdvalgListe(dataReturn.Udvalg);

            if (initial) {
                setValuesFromHash();
                $(".search_filter_button > button[type=submit]").prop("disabled", false);
            }
            $("#soeg .spinner").hide();

        },
        error: function (error) {
            $("#soeg .spinner").hide();
            ShowErrorDialog(error.responseJSON);
        }
    });
}

function setLatestMeetingView(udvalg) {
    var nullAfsluttet = false;
    SetSearchResultBoxHeaderPostfix(localization.getText("Localization_js_LatestMeetings"));
    var allMeetings = [];
    $.each(udvalg, function (navn, udvalg) {
        if (udvalg.length === 1) {
            udvalg[0].Moeder.forEach(function (m, i) {
                allMeetings.push(FormResult(udvalg[0].Navn, m.Id, m.Dato, nullAfsluttet ? null : m.Afsluttet, m.IsSupplementaryAgenda));
            })
        } else if (udvalg.length > 1) {
            $.each(udvalg, function (i, subUdvalg) {
                subUdvalg.Moeder.forEach(function (m, i) {
                    allMeetings.push(FormResult(subUdvalg.Navn, m.Id, m.Dato, nullAfsluttet ? null : m.Afsluttet, m.IsSupplementaryAgenda));
                })
            });
        }
    });

    allMeetings.sort(function (a, b){return (a.Moede.Dato > b.Moede.Dato) ? -1 : ((b.Moede.Dato > a.Moede.Dato) ? 1 : 0)});
    renderResultater({Dagsordner: allMeetings.slice(0,10)}, 1, 0);
}

function FormResult(udvalgsnavn, moedeId, moedeDato, afsluttet, isSupplementaryAgenda) {
    return {
        Id: moedeId,
        Moede: {
            Dato: moedeDato,
            Afsluttet: afsluttet,
            IsSupplementaryAgenda: isSupplementaryAgenda
        },
        Udvalg: {
            Navn: udvalgsnavn
        }
    }
}

function createDropdownHtml(data) {
    var content =
        "<div id='udvalg-navigation' data-udvalgnavigation data-valuetarget='#udvalg' data-titletarget='#udvalg-title' class='multidropdown-container' aria-owns='udvalg-dropdown-ul'>" +
        "<a tabindex='0' data-title id='udvalg-title' class='title' aria-expanded='false'><span class='multiDropdownPlaceholder' >" + localization.getText("Localization_js_Choose_Committees") + "</span><span class='caret ul-caret pull-right'></span></a>" +
        "<ul id='udvalg-dropdown-ul' class='udvalg-dropdown-ul'>";
    $.each(data, function (navn, udvalg) {
        if (udvalg.length === 1) {
            content += "<li><a data-value=\'" + udvalg[0].Id + "\' href='#'>" + navn + "</a></li>";
        } else if (udvalg.length > 1) {
            content += "<li><a href='#' aria-label='" + navn + " " + localization.getText("Localization_js_Choose_Committees_Submenu_Aria") + "'>" + navn + "<span class='caret ul-caret pull-right'></span></a><ul>";
            $.each(udvalg, function (i, subUdvalg) {
                content += "<li><a href='#' data-value=\'" + subUdvalg.Id + "\' aria-label=\'" + subUdvalg.Navn + localization.getText("Localization_js_Choose_Committees_Submenu_Choice_Aria") + navn + "\'>" + subUdvalg.Navn + "</a></li>"
            });

            content += "</ul></li>";
        }
    });

    content += "</ul></div>";

    return content;
}

function GetUniqueValues(value, index, array) {
    return array.indexOf(value) === index;
}

function createYearDropdownHtml(data) {
    var content =
        "<div id='year-navigation' data-yearnavigation data-valuetarget='#year' class='year-navigation multidropdown-container' aria-owns='dato-dropdown-ul'>" +
        "<a tabindex='0' data-title id='year-title' class='title' aria-expanded='false'><span class='multiDropdownPlaceholder' >" + localization.getText("Home-Search_Date_Placeholder") + "</span><span class='caret ul-caret pull-right'></span></a>" +
        "<ul id='year-dropdown-ul' class='year-dropdown-ul'>";

    var allMeetingYears = [];
    $.each(data, function (navn, udvalg) {
        if (udvalg.length === 1) {
            udvalg[0].Moeder.forEach(function (m) {allMeetingYears.push(m.Dato.substring(0,4))});
        } else if (udvalg.length > 1) {
            $.each(udvalg, function (i, subUdvalg) {
                subUdvalg.Moeder.forEach(function (m) {allMeetingYears.push(m.Dato.substring(0,4))});
            });
        }
    });

    var groupedByDecade = getMeetingYearsGroupedByDecade(allMeetingYears);

    var currentDate = getDecadeFromYear((new Date).getFullYear());
    groupedByDecade.forEach(function(g, decade) {
        if (decade === currentDate.decade){
            g.forEach(function(y) {
                content += "<li><a data-value=\'" + y + "\' href='#'>" + y + "</a></li>";
            });
        } else {
            content += "<li><a href='#' aria-label='" + decade + " " + localization.getText("Localization_js_Choose_Committees_Submenu_Aria") + "'>" + decade + "<span class='caret ul-caret pull-right'></span></a><ul>";
            g.forEach(function(y) {
                content += "<li><a href='#' data-value=\'" + y + "\' aria-label=\'" + y + localization.getText("Localization_js_Choose_Committees_Submenu_Choice_Aria") + y + "\'>" + y + "</a></li>"
            })
            content += "</ul></li>";

        }
    })

    content += "</ul></div>";

    return content;
}

function getMeetingYearsGroupedByDecade(allMeetingYears) {
    allMeetingYears = allMeetingYears.filter(GetUniqueValues).sort().reverse();
    var allMeetingDecades = []
    allMeetingYears.forEach(function (y) {
        allMeetingDecades.push(getDecadeFromYear(y));
    })
    var groupedByDecade = groupYearsByDecade(allMeetingDecades)
    return groupedByDecade;
}
function groupYearsByDecade(meetingDateObjects) {
    let result = new Map;
    for (let i = 0; i < meetingDateObjects.length; i++) {
        const currentObj = meetingDateObjects[i];
        let doesGroupExist = result.get(currentObj.decade);
        if (!doesGroupExist) {
            result.set(currentObj.decade, []);
        }
        let existingGroup = result.get(currentObj.decade);
        existingGroup.push(currentObj.year);
    }

    return result;
}

function getDecadeFromYear(year) {
    const decade = (year + "").slice(0, -1);
    return {decade: decade + "0-"+decade.slice(-1) + "9", year: year};
}

function initDropdownHide() {
    window.addEventListener('click', function (e) {
        hideIfElementIsNotTarget("udvalg-navigation", e);
        hideIfElementIsNotTarget("year-navigation", e);
    });
}

function hideIfElementIsNotTarget(elementId, mouseEvent){
    var element = document.getElementById(elementId);
    if (element && !element.contains(mouseEvent.target)) {
        setDropdownUlDisplay('#' + elementId, "none");
    }
}

function setDropdownUlDisplay(navigationtag, displayProp) {

    var udvalgDropdownUl = document.querySelector(navigationtag + " > ul");

    if (udvalgDropdownUl !== null && udvalgDropdownUl !== undefined) {
        udvalgDropdownUl.style.display = displayProp;
    }
    var titleElement = document.querySelector(navigationtag + " > [data-title]");
    titleElement.setAttribute("aria-expanded", displayProp === "block")
}

function resetDropdown(e) {
    resetDropdownByTarget(e.target.dataset.target);
}

function resetDropdownByTarget(target) {
    var targetDropdownElement = $(target);
    targetDropdownElement.val('');
    targetDropdownElement.trigger("change");
    var placeholderText = document.querySelector(target).dataset.placeholderText;
    var placeholderTitleElement = document.querySelector(target).dataset.placeholderTarget;
    $(placeholderTitleElement).html('<span class=\'multiDropdownPlaceholder\' >' + placeholderText + '</span><span class=\'caret ul-caret pull-right \'></span>');
    window.loadFirstLoadDates();

    var parameters = getParameters();
    setUrlFromInputVariables(parameters);
}

function resetDropdownOnKeyPress(e) {
    if (e.keyCode === enterKeyCode || e.keyCode === spaceKeyCode) {
        e.stopPropagation();
        resetDropdownByTarget(e.target.dataset.target);
    }
}

function initMultiDropdowns(dropdownDatatag) {
    var dropdownelement = document.querySelector(dropdownDatatag);
    var $ul = $(dropdownDatatag + ' > ul');

    $ul.find('li a').click(function (e) {
        var $li = $(this).parent();

        if ($li.find('ul').length > 0) {
            e.preventDefault();

            if ($li.hasClass('selected')) {
                $li.removeClass('selected').find('li').removeClass('selected');
                $li.find('ul').slideUp(200);
            } else {

                if ($li.parents('li.selected').length === 0) {
                    $ul.find('li').removeClass('selected');
                    $ul.find('ul').slideUp(200);
                } else {
                    $li.parent().find('li').removeClass('selected');
                    $li.parent().find('> li ul').slideUp(200);
                }

                $li.addClass('selected');
                $li.find('>ul').slideDown(200);
            }
        } else {
            var selText = $(this).text();
            var value = $(this).data("value");

            var udvalgElement = document.querySelector(dropdownelement.dataset.valuetarget);
            udvalgElement.value = value;
            udvalgElement.dispatchEvent(new Event("change"));
            var titleElement = dropdownelement.querySelector("[data-title]");
            titleElement.innerHTML = selText + '<div class="dropdownAndClearContainer"><span tabindex="0" aria-label="' + localization.getText("Localization_js_Reset_Chosen_Committee_Aria") + '" onkeydown="window.resetDropdownOnKeyPress(event);" onclick="window.resetDropdown(event);" class=\'glyphicon glyphicon-remove resetCross pull-right\' data-target="' + dropdownelement.dataset.valuetarget + '"></span><span class=\'caret ul-caret pull-right\'></span></div>';
            setDropdownUlDisplay(dropdownDatatag, "none")

        }
    });

    $ul.find('li a').bind('keydown', function (e) {
        if (e.keyCode === enterKeyCode || e.keyCode === spaceKeyCode) { // Enter or Space
            $(this).trigger('click');
            e.preventDefault();
        } else if (e.keyCode === 38) { //arrowUp
            var previousItemInGroup = $(this).parent().prev();
            if (previousItemInGroup[0]) {
                previousItemInGroup.find("a").focus();
            } else {
                var parentGroup = $(this).parent().parent().parent().find("a")[0];
                parentGroup.focus();
            }
        } else if (e.keyCode === 40) { //arrowDown
            var innerGroup = $(this).next("ul");
            if (innerGroup[0] && innerGroup.is(':visible')) {
                $(this).parent().find("a")[1].focus();
            } else {
                var nextItemInGroup = $(this).parent().next().find("a")[0];
                if (nextItemInGroup) {
                    nextItemInGroup.focus();
                } else {
                    var nextGroup = $(this).parent().parent().parent().next("li");
                    if (nextGroup[0]) {
                        nextGroup.find("a")[0].focus();
                    }
                }
            }
        }
    });

    $(dropdownDatatag + ' > ul ul').each(function (i) {
        if ($(this).find('>li>ul').length > 0) {
            var paddingLeft = $(this).parent().parent().find('>li>a').css('padding-left');
            var pIntPLeft = parseInt(paddingLeft);
            var result = pIntPLeft + 20;

            $(this).find('>li>a').css('padding-left', result);
        } else {
            var paddingLeft = $(this).parent().parent().find('>li>a').css('padding-left');
            var pIntPLeft = parseInt(paddingLeft);
            var result = pIntPLeft + 20;

            $(this).find('>li>a').css('padding-left', result).parent().addClass('selected--last');
        }
    });

    var activeLi = $('li.selected');
    if (activeLi.length) {
        opener(activeLi);
    }

    function opener(li) {
        var ul = li.closest('ul');
        if (ul.length) {

            li.addClass('selected');
            ul.addClass('open');

            if (ul.closest('li').length) {
                opener(ul.closest('li'));
            } else {
                return false;
            }

        }
    }

    $(dropdownDatatag + ' > .title').click(function () {
        if ($ul[0].style.display === 'none' || $ul[0].style.display == '') {
            setDropdownUlDisplay(dropdownDatatag,'block');
        } else {
            setDropdownUlDisplay(dropdownDatatag, "none");
        }
    });

    $(dropdownDatatag + ' > .title').bind('keydown', function (e) {
        if (e.keyCode === enterKeyCode || e.keyCode === spaceKeyCode) { // Enter or Space
            $(this).trigger('click');
            e.preventDefault();
        } else {
            if (e.keyCode === 40) { //arrowDown
                $(this).next().find("a")[0].focus();
            }
        }
    });
}

function ShowErrorDialog(supplerendeFejl) {
    $("#supplerende-fejlbesked").html(supplerendeFejl)
    $('#errorDialog').modal('show');
}

function getUdvalg(udvalgId) {

    var select = {
        "Id": "true",
        "Navn": "true",
        "Moeder": {
            "Id": "true",
            "Dato": "true",
            "Sted": "true"
        }
    };

    var url = "/api/agenda/udvalg/" + udvalgId + "?request.select=" + encodeURIComponent(JSON.stringify(select));

    $.ajax({
        url: url,
        type: "GET",
        async: true,
        dataType: "json",
        success: function (data) {
            filtrerDateTimePicker(getMoedeDatoer(data.Moeder), true);
        },
        error: function (error) {
            ShowErrorDialog(error.responseJSON);
        }
    });
}

function setUdvalgListe(udvalgsliste) {
    var dates = [];

    $("#udvalg, .date").prop("disabled", false);

    $.each(udvalgsliste, function (i, subudvalgsListe) {
        $.each(subudvalgsListe, function (i, subudvalg) {
            $.merge(dates, getMoedeDatoer(subudvalg.Moeder));
        });
    });

    filtrerDateTimePicker(dates, false);
    window.setFirstLoadDates(dates);
}

function getMoedeDatoer(moeder) {
    var dates = [];

    $.each(moeder, function (i, value) {
        var date = moment(value.Dato).format("DD-MM-YYYY");

        if ($.inArray(date, dates) === -1) {
            dates.push(date);
        }
    });

    return dates;
}

function filtrerDateTimePicker(dates, clear) {
    var event = new CustomEvent("activeDatesChanged", {detail: dates});
    window.dispatchEvent(event);
    if (clear) {
        $(".date").val("");
    }
}

function getValuesFromHash() {
    var attributes = Object.fromEntries((new URLSearchParams(window.location.search)).entries());

    var fritekst = null;
    var udvalgId = null;
    var date = null;

    if (attributes["request.kriterie.fritekst"]) {
        fritekst = attributes["request.kriterie.fritekst"];
    }

    if (attributes["request.kriterie.udvalgId"]) {
        udvalgId = attributes["request.kriterie.udvalgId"];
    }

    if (attributes["request.kriterie.moedeDato"]) {
        date = attributes["request.kriterie.moedeDato"];
    }

    if(!fritekst && !udvalgId && !date) {
        var hash = decodeURIComponent(window.location.hash);

        attributes = hash.substring(1).split("&");

        $.each(attributes, function (i, item) {
            if (item.indexOf("request.kriterie.fritekst") > -1) {
                fritekst = decodeURIComponent(item.substring(item.indexOf("=") + 1));
            }

            if (item.indexOf("request.kriterie.udvalgId") > -1) {
                udvalgId = item.substring(item.indexOf("=") + 1);
            }

            if (item.indexOf("request.kriterie.moedeDato") > -1) {
                date = decodeURIComponent(item.substring(item.indexOf("=") + 1));
            }
        });
    }

    return {
        Fritekst: fritekst,
        UdvalgId: udvalgId,
        Date: date
    };
}

function setValuesFromHash() {
    var values = getValuesFromHash();

    $("#startindex").val("0");
    var doSearch = false;

    if (values.Fritekst) {
        $("#searchterm").val(values.Fritekst);
        doSearch = true;
    }

    if (values.UdvalgId) {
        $("#udvalg").val(values.UdvalgId);
        var udvalsNavn = document.querySelector('[data-value="'+ values.UdvalgId+ '"]').innerHTML;
        if (!!udvalsNavn){
            $("#udvalg-title").html(udvalsNavn + '<div class="dropdownAndClearContainer"><span tabindex="0" aria-label="' + localization.getText("Localization_js_Reset_Chosen_Committee_Aria") + '" onkeydown="window.resetDropdownOnKeyPress(event);" onclick="window.resetDropdown(event);" class=\'glyphicon glyphicon-remove resetCross pull-right\' data-target="#udvalg"></span><span class=\'caret ul-caret pull-right\'></span></div>');
        }

        doSearch = true;
    }

    if (values.Date) {
        document.querySelector("#year").value = values.Date;
        document.querySelector("[data-yearnavigation]").querySelector("[data-title]").innerHTML = values.Date + '<div class="dropdownAndClearContainer"><span tabindex="0" aria-label="' + localization.getText("Localization_js_Reset_Chosen_Committee_Aria") + '" onkeydown="window.resetDropdownOnKeyPress(event);" onclick="window.resetDropdown(event);" class=\'glyphicon glyphicon-remove resetCross pull-right\' data-target="#year"></span><span class=\'caret ul-caret pull-right\'></span></div>';
        doSearch = true;
    }

    if (doSearch) {
        moreToBeSearched = true;
        executeSearch(0);
        var pagingLimit = $("#paginglimit").val();
        $("#startindex").val(pagingLimit);
    }
}

function initSoeg() {
    $("#soeg").submit(function (e) {
        moreToBeSearched = true;
        executeSearch(0);
        $("#startindex").val($("#paginglimit").val());

        e.preventDefault();
    });

    $('#datepicker-close-date').html(localization.getText("Common_close"));
}

function scrollToResults() {
    $('html, body').animate({
        scrollTop: $("#resultater").offset().top
    }, 1000);
}

function filtrerData(searchData) {
    var unikkeDagsordenIds = [];

    searchData.Dagsordner = $.grep(searchData.Dagsordner, function (elm, index) {
        if (unikkeDagsordenIds.indexOf(elm.Id) === -1) {
            unikkeDagsordenIds.push(elm.Id);
            return true;
        }
        return false;
    });

    return searchData;
}

function SetSearchResultBoxHeaderPostfix(text) {
    document.getElementById("antalresultaterPostfix").innerHTML = text;
}

function executeSearch(startIndex) {
    if (!validateInput() || !moreToBeSearched || executingSearch) return;
    SetSearchResultBoxHeaderPostfix(localization.getText("Home-Search_Results"));
    executingSearch = true;

    if (startIndex === 0) {
        $("#resultatplaceholder > .spinner").show();
        $("#resultatplaceholder > #resultater").hide();
    } else {
        $("#resultatplaceholder > #resultater .spinner").show();
    }

    var select = {
        "Id": "true",
        "TillaegsDagsorden": "true",
        "Udvalg": {
            "Navn": "true"
        },
        "Moede": {
            "Id": "true",
            "Dato": "true",
            "Afsluttet": "true"
        }
    };

    var parameters = getParameters();

    setUrlFromInputVariables(parameters);

    var limit = $("#paginglimit").val();

    parameters += "&request.paging.startIndex=" + startIndex;
    parameters += "&request.paging.limit=" + limit;

    var url = "/api/agenda/soeg/?request.select=" + encodeURIComponent(JSON.stringify(select)) + parameters;

    $.ajax({
        url: url,
        type: "GET",
        async: true,
        timeout: 99999999,
        dataType: "json",
        success: function (data) {
            var pageResultCount = data.Dagsordner.length;

            var filtreretData = filtrerData(data);
            renderResultater(filtreretData, startIndex, limit);

            if (filtreretData.Dagsordner.length < pageResultCount) {
                triggerInfiniteScroll();
            }

            if (!data.MoreToBeSearched) {
                moreToBeSearched = false;
            } else {
                executingSearch = false;
                PrefillinfiniteScroll();
            }

            $("#resultaterplaceholder a").first().focus();
        },
        error: function (error) {
            $("#resultatplaceholder .spinner").hide();
            ShowErrorDialog(error.responseJSON)
        },
        complete: function () {
            executingSearch = false;
        }
    });
}

function getParameters() {
    var fritekst = $("#searchterm").val();
    var udvalgId = document.querySelector("#udvalg").value;
    var year = document.querySelector("#year").value;

    var parameters = "";
    parameters += "&request.kriterie.udvalgId=" + udvalgId;

    if (fritekst.trim()) {
        parameters += "&request.kriterie.fritekst=" + encodeURIComponent(fritekst);
    }
    if (year) {
        parameters += "&request.kriterie.moedeDato=" + encodeURIComponent(year);
    }
    return parameters;
}

function setUrlFromInputVariables(parameters) {
    window.history.pushState("", "", "?" + parameters.substring(1));
}

function triggerInfiniteScroll() {
    if (!executingSearch) {

        var limit = $("#paginglimit").val();

        var startIndex = $("#startindex");
        executeSearch(startIndex.val());
        startIndex.val(parseInt(startIndex.val()) + parseInt(limit));
    }
}

function PrefillinfiniteScroll() {
    if ($(window).height() >= $(document).height()) {
        triggerInfiniteScroll();
    }
}

function enableInfiniteScroll() {

    var scrollTimer, lastScrollFireTime = 0;

    $(window).off("scroll").on("scroll", function () {

        var minScrollTime = 100;
        var now = new Date().getTime();

        function processScroll() {
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
                triggerInfiniteScroll();
            }
        }

        if (!scrollTimer) {
            if (now - lastScrollFireTime > (3 * minScrollTime)) {
                processScroll();
                lastScrollFireTime = now;
            }
            scrollTimer = setTimeout(function () {
                scrollTimer = null;
                lastScrollFireTime = new Date().getTime();
                processScroll();
            }, minScrollTime);
        }
    });
}

function validateInput() {
    var searchterm = $("#searchterm").val();
    var udvalg = $("#udvalg").val();
    var date = document.querySelector("#year").value;

    if (searchterm || (udvalg && udvalg !== "-1") || date) {
        return true;
    }

    alert(localization.getText("Localization_js_At_Least_One_Criteria"));

    return false;
}

function renderResultater(data, startIndex, limit) {
    $("#ingen-publicerede-besked").hide();

    var template;
    if (startIndex > 0) {
        template = setDagsordenerData(data.Dagsordner);
        $("#resultaterplaceholder").append(template);
    } else {

        if (data.AntalResultater > 0) {
            if (apiVersion === 0) {
                $("#antalresultater").html(data.AntalResultater);

            } else if (apiVersion === 1) {
                $("#antalresultater").html("");
            }

            template = setDagsordenerData(data.Dagsordner);
            $("#resultaterplaceholder").html(template);

        } else {

            if (data.IkkePubliceredeMoeder) {
                $("#antalresultater").html(localization.getText("Localization_js_Non_Published"));
                $("#ingen-publicerede-besked").show();
            } else {
                $("#antalresultater").html(localization.getText("Localization_js_Non"));
            }

            $("#resultaterplaceholder").empty();
        }

        if (parseInt(startIndex) === 0 && data.AntalResultater <= limit) {
            scrollToResults();
            enableInfiniteScroll();
        }
    }

    $("#resultater").show();

    $("#resultatplaceholder .spinner").hide();

    $(".searchresult").off("click").on("click", function (e) {
        var values = getValuesFromHash();

        if (values.Fritekst) {
            e.preventDefault();

            var url = $(this).attr("href");

            var fritekst = encodeURIComponent(values.Fritekst);

            window.location.href = url + "&fritekst=" + fritekst;
        }
    });
}
function GetStatusText(meeting){
    const meetingStatus = meeting.Afsluttet ? localization.getText("Localization_js_Meeting_Minutes") : localization.getText("Localization_js_Agenda");

    return meeting.IsSupplementaryAgenda ? `${meetingStatus} (${localization.getText("Localization_js_Supplementary_Agenda")})` : meetingStatus;
}

function setDagsordenerData(dagsordner) {
    var template = "";

    $.each(dagsordner, function (i, value) {
        var status = GetStatusText(value.Moede);

        var iFrame = $("body").hasClass("iframe") ? "&iframe=true" : "";
        var description = getDescription(value);
        template += "<a href='" + "/vis?" + description +"&id=" + value.Id + iFrame + "' class='list-group-item searchresult' aria-label='" + localization.getText("Global_Show") + " " + (i + 1) + " " + localization.getText("Global_Of") + " " + dagsordner.length + " " + moment(value.Moede.Dato).format("DD-MM-YYYY") + " " + value.Udvalg.Navn + " " + status + "'>"
            + "<div class='row'>"
            + "<div class='col-sm-3'>" + moment(value.Moede.Dato).format("DD/MM-YYYY") + "</div>"
            + "<div class='col-sm-5 break-word'>" + "<strong>" + value.Udvalg.Navn + "</strong>" + "</div>"
            + "<div class='col-sm-4 link'>" + "<strong>" + status + "</strong>" + "<span class='glyphicon glyphicon-play' aria-hidden='true'></span>" + "</div>"
            + "</div>"
            + "</a>";
    });

    return template;
}
function getDescription(value){
    var prefix = value.Moede.Afsluttet ? localization.getText("Localization_js_Meeting_Minutes") : localization.getText("Localization_js_Agenda");
    var committeeName = encodeURIComponent(replaceMostCommonSpecialChars(value.Udvalg.Navn));
    var dateObj = new Date(value.Moede.Dato);
    var year = dateObj.getFullYear();
    var month = toTwoDigitFormat(dateObj.getMonth() + 1);
    var date = toTwoDigitFormat(dateObj.getDate());
    var hour = toTwoDigitFormat(dateObj.getHours());
    var minut = toTwoDigitFormat(dateObj.getMinutes());
    var time = hour + "." + minut;
    var finishedDate = "d." + date + "-" + month + "-" + year + "-" + localization.getText("Localization_js_TimeShothand") + time;
    return encodeURIComponent(prefix + "-") + committeeName + encodeURIComponent("-" + finishedDate);
}

function replaceMostCommonSpecialChars(value){
    return value
        .replaceAll("æ", "ae")
        .replaceAll("Æ", "Ae")
        .replaceAll("ø", "oe")
        .replaceAll("Ø", "Oe")
        .replaceAll("å", "aa")
        .replaceAll("Å", "Aa")
        .replaceAll(" ", "-")
        .replaceAll("'", "")
}

function toTwoDigitFormat(value){
    return value < 10 ? "0" + value : value;
}

function initFieldReset() {
    $(".field-reset").off("click").on("click", function () {
        resetDropdownByTarget("#udvalg")
        resetDropdownByTarget("#year")
        document.querySelector("#searchterm").value = '';
    });
}



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/home.js
// module id = 0
// module chunks = 2